import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import {
  FORM_CACHE_UI_STATUS,
  FORM_CACHE_UI_STATUS_LABEL_MAX_CHARS,
} from '#/modules/momMgmt/workOrder/transfer/helper/formCacheUiStatus';

const TONE_BY_STATUS = {
  [FORM_CACHE_UI_STATUS.CONFLICT]: 'danger',
  [FORM_CACHE_UI_STATUS.SYNC_FAILED]: 'danger',
  [FORM_CACHE_UI_STATUS.INVALID_AFTER_RESTORE]: 'danger',
  [FORM_CACHE_UI_STATUS.LOCAL_SAVED]: 'warning',
  [FORM_CACHE_UI_STATUS.SYNCING]: 'warning',
  [FORM_CACHE_UI_STATUS.RESTORE_AVAILABLE]: 'warning',
  [FORM_CACHE_UI_STATUS.CONSUMED]: 'warning',
  [FORM_CACHE_UI_STATUS.SERVER_SYNCED]: 'info',
};

const TONE_CLASS = {
  danger: 'text-red-600 bg-red-50 border-red-200',
  warning: 'text-amber-800 bg-amber-50 border-amber-200',
  info: 'text-slate-600 bg-slate-50 border-slate-200',
};

/**
 * 工單轉倉 Create form-cache 狀態條（風格接近 FormValidationSummary／form_error）。
 * 寬度隨文案：w-fit，max-width＝定稿文案最長字數 rem，勿拉滿整列。
 */
const FormCacheStatusBanner = ({
  status,
  label,
  actions = [],
  className,
}) => {
  if (!label) {
    return null;
  }

  const tone = TONE_BY_STATUS[status] || 'info';

  return (
    <div
      className={cn(
        `
          w-fit p-2.5 text-sm
          border rounded-md
          flex flex-wrap items-center gap-2
        `,
        TONE_CLASS[tone],
        className,
      )}
      style={{ maxWidth: `${FORM_CACHE_UI_STATUS_LABEL_MAX_CHARS}rem` }}
      role="status"
    >
      <p>{label}</p>
      {actions.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {actions.map((action) => (
            <Button
              key={action.id}
              type="button"
              size="sm"
              variant="outline"
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

FormCacheStatusBanner.propTypes = {
  status: PropTypes.string,
  label: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  })),
  className: PropTypes.string,
};

export default FormCacheStatusBanner;
